import React, { useEffect } from "react";
import { useRouteMatch } from "react-router-dom";
import { useQuery } from "@apollo/react-hooks";
import { ACCOUNT } from "../queries";
import Base from "../../core/components/Base";
import BaseNotFoundPage from "../../core/pages/BaseNotFoundPage";
import WhiteBox from "../../core/components/WhiteBox";
import AccountForm from "../components/AccountForm";

const EditAccountPage = () => {
  /**
   * Page for editing a account
   */

  const accountId = useRouteMatch("/money/:id").params.id;

  const {loading, data, error} = useQuery(ACCOUNT, {variables: {id: accountId}});
  const account = loading || error ? {measurements: {edges: []}} : data.user.account;

  
  useEffect(() => {
    if (!loading) {
      document.title = `${account.name} - lytiko`;
    }
  });

  if (error) {
    try {
      const message = JSON.parse(error.graphQLErrors[0].message);
      if (message.account === "Does not exist") {
        return <BaseNotFoundPage />
      }
    } catch {  }
  }

  if (loading) {
    return (
      <Base className="edit-account-page">
        <WhiteBox className="account-form" loading={true} />
      </Base>
    )
  }

  return (
    <Base className="edit-account-page">
      <AccountForm account={account} loading={loading} />
    </Base>
  )
}

export default EditAccountPage;